export default __webpack_public_path__ + "static/media/s6.51225bf9.jpg";